export default {
  lang: {
    selectAll: 'Alle Seiten auswählen',
    selected: 'Ausgewählt',
    term: 'Artikel',
    deselect: 'Abbrechen der Auswahl',
  },
};
